/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {LabelListResponse, LabelResponse} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({providedIn: 'root'})
export class LabelService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * @summary Get Labels
   */
  getLabels<TData = LabelListResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getLabels<TData = LabelListResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getLabels<TData = LabelListResponse>(options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getLabels<TData = LabelListResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/labels`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns all label records associated with the given label name
   * @summary Get Label Types By Name
   */
  getLabelsByName<TData = LabelResponse[]>(labelName: string, options?: HttpClientBodyOptions): Observable<TData>;
  getLabelsByName<TData = LabelResponse[]>(
    labelName: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getLabelsByName<TData = LabelResponse[]>(
    labelName: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getLabelsByName<TData = LabelResponse[]>(
    labelName: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns a single label record associated with the given label name and id
   * @summary Get Label Type By Name And Id
   */
  getLabelByNameAndId<TData = LabelResponse>(
    labelName: string,
    labelId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getLabelByNameAndId<TData = LabelResponse>(
    labelName: string,
    labelId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getLabelByNameAndId<TData = LabelResponse>(
    labelName: string,
    labelId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getLabelByNameAndId<TData = LabelResponse>(
    labelName: string,
    labelId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}/${labelId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}/${labelId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/labels/${labelName}/${labelId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
